import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
// SERVICES
import { AnswerService } from '@services/answer/answer.service';
import { QuestionBankService } from '@services/question-bank/question-bank.service';
import { AlertService } from '@services/notification/alert.service';
// MODELS
import { AnswerBase } from '../answer-base';

@Component({
  selector: 'app-relational-answer',
  templateUrl: './relational-answer.component.html',
  styleUrls: ['./relational-answer.component.scss']
})
export class RelationalAnswerComponent extends AnswerBase {
  constructor(
    fb: FormBuilder,
    alertService: AlertService,
    answerService: AnswerService,
    questionBankService: QuestionBankService,
  ) {
    super(fb, alertService, answerService, questionBankService)
  }

  finishLoadData() {}
}
